import React from 'react';
import classnames from 'classnames';
import { extendWithDefaults } from '@mm/utils';

export const ARROW_TYPES = {
  CHEVRON: 'chevron',
  REGULAR: 'regular',
  CARET: 'caret',
  LONG: 'long',
  TRIANGLE: 'triangle',
};

const ROTATE_DEGREES = {
  top: 0,
  right: 90,
  bottom: 180,
  left: 270,
};

/* tslint:disable */
const ARROW_PATHS = {
  [ARROW_TYPES.LONG]:
    'M1277 493q-9 19-29 19h-224v1248q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-1248h-224q-21 0-29-19t5-35l350-384q10-10 23-10 14 0 24 10l355 384q13 16 5 35z',
  [ARROW_TYPES.CARET]:
    'M1408 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z',
  [ARROW_TYPES.CHEVRON]:
    'M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z',
  [ARROW_TYPES.REGULAR]:
    'M1675 971q0 51-37 90l-75 75q-38 38-91 38-54 0-90-38l-294-293v704q0 52-37.5 84.5t-90.5 32.5h-128q-53 0-90.5-32.5t-37.5-84.5v-704l-294 293q-36 38-90 38t-90-38l-75-75q-38-38-38-90 0-53 38-91l651-651q35-37 90-37 54 0 91 37l651 651q37 39 37 91z',
  [ARROW_TYPES.TRIANGLE]:
    'M7.58242 6.67408L0.888672 0.901424C0.639062 0.686971 0.273438 0.88033 0.273438 1.22662V12.7719C0.273438 13.1182 0.639062 13.3116 0.888672 13.0971L7.58242 7.32447C7.77402 7.15924 7.77402 6.83931 7.58242 6.67408Z',
};
/* tslint:enable */

type Props = {
  onClick?: (event) => any;
  onMouseEnter?: (event) => any;
  onMouseLeave?: (event) => any;
  direction: 'top' | 'right' | 'bottom' | 'left';
  color?: string;
  size?: number;
  className?: string;
  transitionTime?: number;
  arrowType?: string;
  viewBox?: string;
};

const defaultProps = {
  size: 25,
  color: '#435eb2',
  transitionTime: 0.5,
  arrowType: ARROW_TYPES.REGULAR,
  viewBox: '0 0 1792 1792',
};

const ArrowIcon = (props: Props) => {
  const {
    color,
    size,
    className,
    direction,
    transitionTime,
    arrowType,
    onClick,
    onMouseEnter,
    onMouseLeave,
    viewBox,
  } = extendWithDefaults({ props, defaultProps });
  const classList = classnames('arrow-icon', className);
  const rotateDegree = ROTATE_DEGREES[direction];
  // TODO: Fix strict null error
  // @ts-ignore
  const arrowPath = ARROW_PATHS[arrowType];

  const styles = {
    transition: `transform ${transitionTime}s ease`,
    transform: `rotate(${rotateDegree}deg)`,
  };

  return (
    <svg
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classList}
      style={styles}
      width={size}
      height={size}
      viewBox={viewBox}
    >
      <path fill={color} d={arrowPath} />
    </svg>
  );
};

export default ArrowIcon;
